export default  {"src":"/_next/static/image/public/images/icon_sm_wallet.b4edcdbe38ef5eaf723da6b269832e0d.svg","height":21,"width":23};